// extracted by mini-css-extract-plugin
module.exports = {"body":"HarvestForecastCreate_body__2p965","header":"HarvestForecastCreate_header__1B9dS"};